<div class="toast {{ intent() }} f-body-l" [class.inverse]="isInverse()">
  <img class="gradient" src="toast/gradient-{{ intent() }}.svg" alt="" />

  <div class="body" [class.onyx-on-inverse]="isInverse()" #body>
    <onyx-icon [name]="toastIcon()" [size]="16" [frame]="24"></onyx-icon>

    <div class="content">
      <p class="message f-paragraph-s f-medium">
        {{ message() | translate }}
      </p>

      @if (description(); as description) {
        <p class="f-body-m f-muted">{{ description | translate }}</p>
      }
    </div>

    @if (buttons()?.length && buttons(); as buttons) {
      <div class="buttons">
        @for (button of buttons; track button) {
          <onyx-button
            class="button"
            [color]="button.color"
            [variant]="button.variant"
            [size]="button.size"
            [spinner]="button.spinner ?? false"
            (click)="!button.spinner ? button.callback() : null"
          >
            {{ button.text | translate }}
          </onyx-button>
        }
      </div>
    }

    <onyx-close-button
      color="black"
      (click)="closeToast.emit()"
    ></onyx-close-button>
  </div>
</div>
